<template>
    <div>
        <h6 class="heading-small text-muted mb-4">{{ $translate('signature') }}</h6>
        <span :title="activityReleaseCheck ? $translate('activity_release_first') :''" v-b-tooltip.hover>

            <b-button v-if="order.completed === 0" type="button" variant="info" @click="openProcessModal()"  :disabled="activityReleaseCheck || viewMode">{{ $translate('signoff_as_customer') }}</b-button>
        </span>

        <template v-if="!!order.completed">
            <b-row>
                <img :src="order.signature_data" class="w-100" />
            </b-row>
            <hr />
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('comments') + ':' }}</strong>
                </b-col>
                <b-col>{{ order.signee }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('signature_by') }}</strong>
                </b-col>
                <b-col>{{ order.completed_by?.first_name + ' ' + order.completed_by?.last_name }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('signed_at') }}</strong>
                </b-col>
                <b-col>{{ signature_address && signature_address[0] && signature_address[0].display_name }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="6" md="2">
                    <strong>{{ $translate('completed') }}:</strong>
                </b-col>
                <b-col>{{ order.completed_at | filterLocalDateTime }}</b-col>
            </b-row>
        </template>
        <div v-else-if="order.signature === 0" style="padding: 1em 0; text-align: center">
            {{ $translate('received_by_note') }}
        </div>
        <div v-else style="padding: 1em 0; text-align: center">
            {{ $translate('no_signature_data') }}
        </div>
        <b-modal v-model="processModal" id="process-modal" centered header-class="p-0"
                footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" size="lg">
            <template #modal-title="{ ok, cancel }">
                <div class="title-block text-center p-2">
                    {{
                        `${$translate('signoff_as_customer')}`
                    }}
                </div>
                <div class="close-btn sm-mt-2" @click="cancel()">×</div>
            </template>
            <b-card no-body v-if="processModal">
                <b-card-body>
                    <b-form>
                        <b-form-group id="comments-group" :label="$translate('comments')+'/'+$translate('customer_name')" label-for="input-comments" label-cols="12" label-cols-md="3"
                            label-class="font-weight-bold pt-0">
                            <b-form-textarea type="text" id="input-comments" v-model="model.signee" required
                                :placeholder="$translate('enter_comments')" rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>
                        <!-- <div class="form-check">
                            <label class="form-check-label ms-4 lh-base">
                                <input type="checkbox" class="form-check-input top-2" id="input-completed" v-model="model.completed"
                                    name="input-completed" :value="1" :unchecked-value="0" />
                                {{ $translate('completed') }}
                                <i class="input-helper"></i>
                            </label>
                        </div> -->
                        <b-form-group id="comments-group" class="mt-2" :label="$translate('signature')" label-for="input-comments" label-cols="12" label-cols-md="3"
                            label-class="font-weight-bold pt-0">
                            <div class="border border-dark">
                                <vueSignature ref="customer_signature" v-model="model.signature_data" :w="'800px'" :h="'200px'">
                                </vueSignature>
                            </div>
                            <div class="mt-2">
                                <b-button @click="clear">{{$translate('clear')}}</b-button>
                                <b-button @click="undo">{{$translate('undo')}}</b-button>
                            </div>
                        </b-form-group>
                    </b-form>
                </b-card-body>
            </b-card>
            <template #modal-footer="{ ok, cancel }">
                <b-button class="btn-fw" variant="info" @click="submitForm()">
                    {{ $translate('submit') }}
                </b-button>

                <b-button class="btn-fw" variant="info" @click="cancel()">
                    {{ $cancelLabel() }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment"
import dateTimeMixins from '@/mixins/dateTimeMixins'
import popupMixins from '@/mixins/popupMixins'
import vueSignature from "vue-signature"

export default {
    name: 'orders-signature',
    mixins: [ dateTimeMixins, popupMixins ],
    components: {
        vueSignature,
    },
    data() {
        return {
            processModal: false,
            model: {},
            signature_address: null
        }
    },
    filters: {
        formatDateTime(date) {
            return moment(date).format('YYYY-MM-DD hh:mm:ss A')
        },
    },
    props: {
        viewMode: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    mounted() {
        console.log('model-', this.model)
     },
    computed: {
        imagedata() {
            if (this.order) {
                return 'data:image/png;base64,' + this.order.signature_data
            } else {
                return null
            }
        },
        activityReleaseCheck(){
            return (this.model?.type?.do_release_before_completed == 1 && this.model.released == 0) ? true : false;
        }
    },
    watch: {
        order: {
            immediate: true,
            handler: async function (val) {
                this.model = {
                    ...val,
                    signature_data:null,
                }
                if (val.signature_lat != null && val.signature_long != null && val.signature_address == null) {
                    const getAddress = await this.$store.dispatch(
                        'orders/geocodeStreet',
                        { lat: val.signature_lat, long: val.signature_long }
                    )
                    this.signature_address = getAddress
                } else if(val.signature_address) {
                    this.signature_address = [{
                        'display_name': val.signature_address
                    }]
                }
            },
            deep: true,
        },
        model: {
            handler: async function (val) {
                console.log('val-', val)
                this.$emit('input', val);
            },
            deep: true,
        }
    },
    methods: {
        openProcessModal(){
            this.processModal=true;
        },
        saveSignature() {
            var _this = this;
            console.log('Signature is null!', _this.$refs.customer_signature.isEmpty() == true);
            if (_this.$refs.customer_signature.isEmpty()) {
                _this.model.signature_data = null
            } else {
                _this.model.signature_data = _this.$refs.customer_signature.save();
            }
        },
        clear() {
            var _this = this;
            _this.$refs.customer_signature.clear();
        },
        undo() {
            var _this = this;
            _this.$refs.customer_signature.undo();
        },
        submitForm(){
            this.saveSignature()
            navigator.geolocation.getCurrentPosition(async (p) => {
                try {
                    this.updating = true;
                    const id = this.$route.params.id;
                    var lat = p.coords.latitude;
                    var long = p.coords.longitude;
                    const getAddress = await this.$store.dispatch(
                        "orders/geocodeStreet",
                        { lat, long }
                    );
                    const address = {
                        lat: p.coords.latitude,
                        long: p.coords.longitude,
                        signature_address: getAddress[0]?.display_name,
                        signee: this.model?.signee,
                        signature_data: this.model?.signature_data,
                    };
                    // console.log("Add",Address)
                    await this.$store.dispatch("orders/markAsComplete", {
                        id,
                        address,
                    });
                    this.genericToast(
                        this.$translate("activity"),
                        this.$translate("updated"),
                        "success",
                        this.$translate("customer_signoff_completed")
                    );
                } catch (error) {
                    console.error("customer signoff", error);
                    this.doToast(this.$translate("error"), error.message, "danger");
                } finally {
                    this.updating = false;
                    this.processModal = false;
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped></style>